import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { updateRegistrar } from 'API/TRSRegistrar/updateRegistrar';

const useUpdateRegistrar = (onSuccess, onError) => {
    const queryClient = useQueryClient();
    const { currentCompany } = useSelector((state) => state.navigationLists);
    const { requiredScope } = useSelector((state) => state.login);

    const updateRegistrarMutation = async (registrarData) => {
        try {
            const response = await updateRegistrar(
                registrarData,
                requiredScope,
            );
            return response.data;
        } catch (error) {
            console.error('Error updating registrar:', error);
            throw error;
        }
    };

    return useMutation({
        mutationFn: updateRegistrarMutation,
        onSuccess: (data, variables) => {
            // Invalidate and refetch the registrars list
            queryClient.invalidateQueries({
                queryKey: ['Registrars', currentCompany],
            });
            queryClient.invalidateQueries({ queryKey: ['Registrars'] });
            // Invalidate the specific registrar being edited
            queryClient.invalidateQueries({
                queryKey: ['Registrar', variables.id],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useUpdateRegistrar;
